import { NavLink } from "react-router-dom"


const CustomPagination = () => {
    return (
        <div className="d-flex justify-content-between mt-0 custom-pagination-container">
            <div className="col-sm-12 col-md-5">
                <div className="dataTables_info" role="status" aria-live="polite">Showing 1 to 10 of 14 entries</div>
            </div>
            <div className="pagination-wrap hstack gap-2">
                <NavLink className="page-item pagination-prev disabled" to='#'>
                    Previous
                </NavLink>
                <ul className="pagination listjs-pagination mb-0"><li className="active">
                    <NavLink className="page" to="#" data-i="1" data-page="8">1</NavLink></li>
                    <li >
                    <NavLink className="page" to="#" data-i="1" data-page="8">2</NavLink></li></ul>
                <NavLink className="page-item pagination-next" to="#">
                    Next
                </NavLink>
            </div>
        </div>
    )
}

export default CustomPagination